interface Blog {
  image: string;
  title: string;
  description: string;
  paragraph: string;
  date: string;
  category: string;
  blogid:string;

}

export const blogs: Blog[] = [
  {
    image: "/blog/blog01.jpg",
    title: "The Best Pizza in Town",
    description: "Discover the tastiest pizza spots around the city.",
    paragraph:
      "From wood-fired ovens to artisanal ingredients, pizza lovers will rejoice at the sheer variety of pizza styles available. Whether you're a fan of thin crust or deep dish, this guide will lead you to the best spots for an unforgettable slice.",
    date: "2024-09-01",
    category: "pizza",
    blogid:"fDwvHJn"
  },
  {
    image: "/blog/blog02.jpg",
    title: "How to Brew the Perfect Coffee",
    description: "Step-by-step guide to making a rich cup of coffee.",
    paragraph:
      "Brewing the perfect coffee is an art, but it doesn’t have to be complicated. With the right tools and techniques, anyone can brew a cup that rivals the best coffee shops. Learn the secrets to achieving the ideal balance of strength and flavor.",
    date: "2024-08-29",
    category: "drink",
    blogid:"8YuSqh7yiJNQs"
  },
  {
    image: "/blog/blog03.jpg",
    title: "Healthy Food Options for Busy People",
    description: "Quick and nutritious meals you can make in a snap.",
    paragraph:
      "In today’s fast-paced world, eating healthy doesn’t have to be time-consuming. With these simple, nutritious meal ideas, you can fuel your body without sacrificing time or flavor. Perfect for those juggling work, family, and a busy lifestyle.",
    date: "2024-09-03",
    category: "food",

blogid:"m5aK7e"},
  {
    image: "/blog/blog04.jpg",
    title: "Top 5 Cozy Restaurants",
    description: "A list of the coziest restaurants to visit this season.",
    paragraph:
      "There’s nothing like a warm, inviting restaurant to make you feel at home. These top picks for cozy dining offer not only delicious food but also a comforting atmosphere perfect for the cooler months ahead.",
    date: "2024-09-10",
    category: "restaurant",
    blogid:"Lpb5CIsYd7D2qFPSM",
  },
  {
    image: "/blog/blog05.jpg",
    title: "Making the Ultimate Margarita",
    description: "Learn how to craft the perfect margarita at home.",
    paragraph:
      "Whether you prefer a classic margarita or enjoy experimenting with unique flavors, this guide will show you how to make the perfect drink. With a few fresh ingredients and a little know-how, your home bar will become everyone’s favorite stop.",
    date: "2024-09-02",
    category: "drink",
    blogid:"Cu7UZFD7xWST4W"
  },
  {
    image: "/blog/blog06.jpg",
    title: "A Guide to the Perfect Thin Crust Pizza",
    description: "Master the art of creating crispy thin crust pizza.",
    paragraph:
      "Thin crust pizza lovers know that the secret to a great pizza lies in the dough. Follow this guide to get that perfectly crispy crust with the right balance of chewiness. You'll never settle for soggy pizza again!",
    date: "2024-09-07",
    category: "pizza",
    blogid:"vjR8RIxMDV"
  },
  {
    image: "/blog/blog07.jpg",
    title: "Comfort Food Classics",
    description: "Explore timeless comfort foods from around the world.",
    paragraph:
      "Comfort food has a way of warming the soul, especially on cold days. From rich stews to hearty casseroles, this collection of recipes will take you on a culinary journey that feels like home.",
    date: "2024-09-08",
    category: "food",

blogid:"8fEDzzVaE3h4B3zv"},
  {
    image: "/blog/blog12.jpg",
    title: "Wine Pairing for Beginners",
    description: "Tips on selecting the best wines to pair with any meal.",
    paragraph:
      "Choosing the right wine can elevate any meal, but it doesn’t have to be intimidating. This beginner-friendly guide will help you understand basic wine pairings, making every dining experience a little more special.",
    date: "2024-08-31",
    category: "drink",
    blogid:"oJL2d1nYiYXLkwXg"
  },
  {
    image: "/blog/blog11.jpg",
    title: "The Pizza Dough Recipe You Need",
    description: "This simple dough recipe will elevate your homemade pizza.",
    paragraph:
      "The foundation of every great pizza is its dough. Whether you prefer a thick and chewy base or something light and crispy, this easy-to-follow recipe will help you perfect your homemade pizza game.",
    date: "2024-09-05",
    category: "pizza",
    blogid:"ATfE3xr6EL0"
  },
  {
    image: "/blog/blog08.jpg",
    title: "Exploring New Restaurants in Town",
    description:
      "Check out the latest restaurants offering unique experiences.",
    paragraph:
      "With new restaurants popping up constantly, it can be hard to keep up. This guide highlights some of the newest and most exciting places to dine, where innovation meets culinary excellence.",
    date: "2024-09-12",
    category: "restaurant",
    blogid:"TrWAa7kO",
  },
  {
    image: "/blog/blog09.jpg",
    title: "Fresh and Easy Salads",
    description: "Simple and fresh salad recipes for a healthy lifestyle.",
    paragraph:
      "Salads don’t have to be boring! With these fresh and flavorful recipes, you’ll see how simple ingredients can come together to make a meal that’s both satisfying and nutritious.",
    date: "2024-09-06",
    category: "food",

blogid:"Hzf5OCR"},
  {
    image: "/blog/blog10.jpg",
    title: "Crafting Unique Cocktails at Home",
    description: "Impress your guests with these easy cocktail recipes.",
    paragraph:
      "With a few creative ingredients and some easy-to-follow instructions, you can create cocktails that are sure to impress. From classic concoctions to innovative twists, this guide has something for every aspiring mixologist.",
    date: "2024-09-04",
    category: "drink",
    blogid:"hYmeluSjEkDHA"
  },
];
